import PropTypes from "prop-types"
import CardPaymentForm from "./CardPaymentForm"
import { Modal } from "ui/Modal"
import { useBreakpoints } from "modules/window/hooks/useBreakpoints"
import CustomDrawer from "ui/Drawer"

const CollectPaymentModal = ({ onOpen, onClose, remainingBalance, bookingUUID, bookingId }) => {
  const breakpoint = useBreakpoints()
  const isMobile = ["xs", "xsm", "sm", "md"].includes(breakpoint)

  const modalContent = (
    <CardPaymentForm onClose={onClose} bookingId={bookingId} bookingUUID={bookingUUID} remainingBalance={remainingBalance} />
  )

  return isMobile ? (
    <CustomDrawer open={onOpen} setOpen={onClose} title="Collect Payment">
      {modalContent}
    </CustomDrawer>
  ) : (
    <Modal centered title="Collect Payment" open={onOpen} onCancel={onClose} width={800}>
      {modalContent}
    </Modal>
  )
}

CollectPaymentModal.propTypes = {
  onOpen: PropTypes.bool,
  onClose: PropTypes.func,
  remainingBalance: PropTypes.number,
  bookingUUID: PropTypes.string,
  bookingId: PropTypes.number
}

export default CollectPaymentModal
